































import { Component, Mixins } from 'vue-property-decorator'
import SettingsCols from '@/components/settings/account/settings-cols/SettingsCols.vue'
import SettingsAddCols from '@/components/settings/account/settings-add-cols/SettingsAddCols.vue'
import SettingsUser from '@/components/settings/account/settings-user/SettingsUser.vue'
import MainUser from '@/components/settings/account/settings-user/main-user/MainUser.vue'
@Component({
  components: {
    SettingsUser,
    SettingsCols,
    SettingsAddCols,
    MainUser,
  },
})
export default class Account extends Mixins() {}
